export default function () {
    (function (d, s) {
        var x = d.createElement(s), s = d.getElementsByTagName(s)[0];
        x.src = "https://www.xing-share.com/js/external/share.js";
        s.parentNode.insertBefore(x, s);
    })(document, "script");
}